module.exports = __webpack_public_path__ + "static/media/bluesign blue.ffc9146d.png";